import { $get, $set } from 'dashboard-js/helpers'
import HighCharts from 'highcharts'
import PortalVue from 'portal-vue'
import ToggleButton from 'vue-js-toggle-button'
import TurbolinksAdapter from 'vue-turbolinks'
import VueChartkick from 'vue-chartkick'
import VueHighcharts from 'vue-highcharts'

window.Vue = require('vue')

Vue.use(VueChartkick, { adapter: HighCharts })
Vue.use(VueHighcharts, { adapter: HighCharts })
Vue.use(require('vue-moment'), { moment })
Vue.use(PortalVue)
Vue.use(ToggleButton)
Vue.use(TurbolinksAdapter)

require('spark-js/filters')
require('dashboard-js/filters')

Vue.mixin({
    computed: {
        // Add spark computed property to all Vue instances
        spark() {
            return window.Spark
        },
    },
})

Vue.prototype.$get = $get
Vue.prototype.$set = $set
